export default __webpack_public_path__ + "static/media/Image-17.66179f1b.jpg";